module.exports = __webpack_public_path__ + "static/rera-letter-2-6aaaa0471e6fa0cc25cc3bf922a7b5dc.jpg";